import EditProfileForm from "./Dashboard/Pages/UserProfile/EditProfileForm.vue";
import UserCard from "./Dashboard/Pages/UserProfile/UserCard.vue";
import Collapse from "../components/Collapse.vue";
// Mock components to replace non-existent imports
const block = {
  template: "<div>block component not available</div>",
  name: "block",
};
const Stripe = {
  template: "<div>Stripe component not available</div>",
  name: "Stripe",
};
const AnonymousOrder = {
  template: "<div>AnonymousOrder component not available</div>",
  name: "AnonymousOrder",
};
const AnonymousAccess = {
  template: "<div>AnonymousAccess component not available</div>",
  name: "AnonymousAccess",
};
const AnonymousResult = {
  template: "<div>AnonymousResult component not available</div>",
  name: "AnonymousResult",
};
const StripePayment = {
  template: "<div>StripePayment component not available</div>",
  name: "StripePayment",
};
const ExerciseListClient = {
  template: "<div>ExerciseListClient component not available</div>",
  name: "ExerciseListClient",
};
import Settings from "./Auth/Settings.vue";

export {
  EditProfileForm,
  UserCard,
  block,
  Stripe,
  AnonymousOrder,
  AnonymousAccess,
  AnonymousResult,
  StripePayment,
  ExerciseListClient,
  Settings,
};
